<template style='height：100%'>
  <div class="box">
    <el-container>
      <el-header>
        <headerList></headerList>
      </el-header>
      <el-main>
        <div class="content">
          <el-form
            ref="form"
            :model="editForm"
            :rules="editFormRules"
            label-width="120px"
            style="padding: 30px; margin: 0 10%"
          >
            <el-form-item label="姓名" prop="cusId">
              <el-select
              style='width:60%;'
                v-model="editForm.cusId"
                placeholder="请选择姓名"
                ref="selectCh"
              >
                <template v-for="item in oldManList">
                  <el-option
                    :label="item.cusName"
                    :value="item.cusId"
                  ></el-option>
                </template>
              </el-select>
            </el-form-item>
            <el-form-item label="联系人" prop="relationName">
              <el-input v-model="editForm.relationName" style='width:60%;'  placeholder="请输入联系人"></el-input>
            </el-form-item>
            <el-form-item label="联系电话" prop="relationPhone"  >
              <el-input v-model="editForm.relationPhone" style='width:60%;' placeholder="请输入联系电话"></el-input>
            </el-form-item>
            <el-form-item label="行为能力" prop="cusPower">
              <el-select v-model="editForm.cusPower" placeholder="请选择老人行为能力" style='width:60%;'>
                <el-option label="自理" value="0"></el-option>
                <el-option label="失能" value="1"></el-option>
                <el-option label="半失能" value="2"></el-option>
                <el-option label="失智" value="3"></el-option>
                <el-option label="轻度依赖" value="4"></el-option>
                <el-option label="重度依赖" value="5"></el-option>
                <el-option label="不能自理" value="6"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="省" prop="province">
              <el-select
               style='width:60%;'
                v-model="editForm.province"
                placeholder="请选择省"
                ref="province"
                @change="getcity(editForm.province)"
              >
                <template v-for="item in province">
                  <el-option
                    :label="item.addName"
                    :value="item.addCode"
                  ></el-option>
                </template>
              </el-select>
            </el-form-item>
            <el-form-item label="市" prop="city">
              <el-select
               style='width:60%;'
                v-model="editForm.city"
                placeholder="请选择市"
                ref="city"
                @change="getarea(editForm.city)"
              >
                <template v-for="item in city">
                  <el-option
                    :label="item.addName"
                    :value="item.addCode"
                  ></el-option>
                </template>
              </el-select>
            </el-form-item>
            <el-form-item label="区" prop="area">
              <el-select
               style='width:60%;'
                v-model="editForm.area"
                placeholder="请选择区"
                ref="area"
              >
                <template v-for="item in area">
                  <el-option
                    :label="item.addName"
                    :value="item.addCode"
                  ></el-option>
                </template>
              </el-select>
            </el-form-item>
            <el-form-item
              label="服务地址"
              prop="serviceAddress"
              v-if="type == 1 || type == 4"
            >
              <el-input v-model="editForm.serviceAddress" style='width:60%;'  placeholder="请输入服务地址"></el-input>
            </el-form-item>

            <el-form-item label="改造范围" v-if="type == 3">
              <el-select v-model="editForm.rangeFlag" placeholder="请选择改造范围" style='width:60%;'>
                <el-option label="阳台" value="0"></el-option>
                <el-option label="卧室" value="1"></el-option>
                <el-option label="厨房" value="2"></el-option>
                <el-option label="客厅" value="3"></el-option>
                <el-option label="卫生间" value="4"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="服务类型">
              <el-select v-model="editForm.type" placeholder="请选择服务类型" style='width:60%;'>
                <el-option
                  label="居家服务"
                  value="1"
                  v-if="type == 1"
                ></el-option>
                <el-option label="机构" value="2" v-if="type == 2"></el-option>
                <el-option
                  label="适老化改造"
                  value="3"
                  v-if="type == 3"
                ></el-option>
                <el-option
                  label="家庭床位"
                  value="4"
                  v-if="type == 4"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="服务套餐" v-if="type == 1">
              <el-select v-model="editForm.serviceType" placeholder="请选择服务套餐" style='width:60%;'>
                <el-option label="助餐" value="1"></el-option>
                <el-option label="助医" value="2"></el-option>
                <el-option label="助洁" value="3"></el-option>
                <el-option label="助浴" value="4"></el-option>
                <el-option label="助乐" value="5"></el-option>
                <el-option label="助急" value="6"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="房屋结构" v-if="type == 3">
              <el-select v-model="editForm.roomStructure" placeholder="请选择房屋结构" style='width:60%;'>
                <el-option label="框架" value="0"></el-option>
                <el-option label="砖混" value="1"></el-option>
                <el-option label="其他" value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="健康状态" v-if="type == 2">
              <el-select v-model="editForm.health" placeholder="请选择健康状态" style='width:60%;'>
                <el-option label="健康" value="0"></el-option>
                <el-option label="高血压" value="1"></el-option>
                <el-option label="糖尿病" value="2"></el-option>
                <el-option label="冠心病" value="3"></el-option>
                <el-option label="恶性肿瘤" value="4"></el-option>
                <el-option label="结核病" value="5"></el-option>
                <el-option label="肝炎" value="6"></el-option>
                <el-option label="脑卒中" value="7"></el-option>
                <el-option label="精神病" value="8"></el-option>
                <el-option label="慢性阻塞性肺疾病" value="9"></el-option>
                <el-option label="慢性支气管炎" value="10"></el-option>
                <el-option label="帕金森综合症" value="11"></el-option>
                <el-option label="腰椎间盘突出" value="12"></el-option>
                <el-option label="阿尔茨海默症" value="13"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="房屋面积"
              prop="roomWidespread"
              v-if="type == 3"
            >
              <el-input v-model="editForm.roomWidespread" style='width:60%;'  placeholder="请输入房屋面积"></el-input>
            </el-form-item>
            <el-form-item label="预约时间">
              <el-col :span="11" style='width:60%;'>
                <el-date-picker
                  type="date"
                  placeholder="选择日期"
                  v-model="editForm.subscribeTime"
                  :picker-options="expireTimeOption"
                  style="width: 100%"
                ></el-date-picker>
              </el-col>
            </el-form-item>
            <el-form-item size="large">
              <el-button type="primary" @click="onSubmit('editForm')"
                >立即申请</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import headerList from "./public/header";
export default {
  name: "serviceList",
  components: { headerList },
  data() {
    return {
      expireTimeOption: {
        disabledDate(date) {
          return date.getTime() <= Date.now();
        },
      },
      form: {
        username: "",
        password: "",
        code: "",
        token: "",
      },
      editForm: {
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: "",
        resource: "",
        desc: "",
      },
      editFormRules: {
        // parentId: [
        //     {required: true, message: '请选择上级菜单', trigger: 'blur'}
        // ],
        cusname: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        relationPhone: [
          { required: true, message: "请填入联系电话", trigger: "blur" },
        ],
        relationName: [
          { required: true, message: "请选填入联系人", trigger: "blur" },
        ],
      },
      userInfo: "",
      type: this.$route.query.type,
      captchaImg: null,
      oldManList: [],
      province: [],
      city: [],
      area: [],
    };
  },
  created() {
    const userInfo = localStorage.getItem("userInfo");
    if (userInfo != null) {
      this.userInfo = JSON.parse(userInfo);
    }
    this.init();
    this.getprovince();
  },
  methods: {
    getprovince() {
      this.$axios.get("/gw/address/child/0").then((res) => {
        if (res.status == 200) {
          this.province = res.data.data;
        }
      });
    },

    getcity(pid) {
      this.$axios.get("/gw/address/child/" + pid).then((res) => {
        if (res.status == 200) {
          this.city = res.data.data;
        }
      });
    },
    getarea(pid) {
      this.$axios.get("/gw/address/child/" + pid).then((res) => {
        if (res.status == 200) {
          this.area = res.data.data;
        }
      });
    },
    onSubmit(formName) {
      this.editForm.userId = this.userInfo.id;
      this.editForm.username = this.userInfo.username;
      this.editForm.createId = this.userInfo.id;
      this.editForm.createName = this.userInfo.username;
      this.editForm.cusname = this.$refs.selectCh.selected.label;
      this.editForm.state = 1;
      this.editForm.province = this.$refs.province.selected.label;
      this.editForm.city = this.$refs.city.selected.label;
      this.editForm.area = this.$refs.area.selected.label;
      this.editForm.serviceAddress =
        this.editForm.province +
        this.editForm.city +
        this.editForm.area +
        this.editForm.serviceAddress;
      this.$axios
        .post("/gw/subscribe/order/save", this.editForm)
        .then((res) => {
          if (res.status == 200) {
            this.$message({
              showClose: true,
              message: "恭喜你，操作成功",
              type: "success",
              onClose: () => {
                this.$router.go(-1); //返回上一层
              },
            });
          } else {
            this.$message({
              message: "创建失败",
              type: "warning",
            });
          }
        });
    },
    init() {
      const uid = this.userInfo.id;
      this.$axios
        .get("/gw/user/customer/list/" + uid, {
          params: {
            // customerName: this.searchForm.name,
            // customerName: this.current,
            // phone: this.size,
            // state:''
          },
        })
        .then((res) => {
          this.oldManList = res.data.data.records;
        });
    },
  },
};
</script>
<style scoped>
.box {
  position: relative;
  top: 0;
  left: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  background: url("../assets/image/background.jpg") no-repeat;
  background-size: 100% 100%;
}

.el-container {
  padding: 0;
  margin: 0;
  width: 100%;
  height: 100%;
}

.el-header {
  width: 100%;
  height: 115px !important;
  line-height: 115px;
  background-color: #fff;
  color: #333;
  text-align: center;
  position: fixed;
  background: rgba(255, 255, 255, 0.8);
  top: 0;
  left: 0;
  z-index: 99;
}

.el-main {
  color: #333;
  padding: 0;
  width: 100%;
}

.content {
  width: 900px;
  height: 900px;
  background: #fff;
  margin: 150px auto;
  position: relative;
  top: 0;
  left: 0;
}

.left-pic {
  width: 141px;
  height: 227px;
  position: absolute;
  bottom: -50px;
  left: -50px;
}

.right-pic {
  width: 242px;
  height: 207px;
  position: absolute;
  bottom: -50px;
  right: -50px;
}

.title {
  width: 137px;
  height: 176px;
  margin: 0 auto;
  font-size: 32px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #f78100;
  line-height: 176px;
}

a {
  text-decoration: none;
}

.form-box {
  width: 460px;
  height: 240px;
  margin: 0 auto;
}

.form-list {
  margin-top: 30px;
  height: 50px;
  border-bottom: 2px solid #c1b8af;
}

.list-left {
  float: left;
  width: 100px;
  height: 50px;
}

.list-left img {
  margin: 10px 35px;
}

.list-right {
  float: left;
  width: 360px;
}

.list-right input {
  border: none;
  height: 50px;
  font-size: 24px;
  width: 100%;
  outline: none;
  background: none;
}

.list-right .code {
  width: 60%;
}

.login {
  width: 460px;
  height: 60px;
  font-size: 24px;
  background: #e73e10;
  border-radius: 30px;
  margin: 0 167px;
}

.register {
  width: 80px;
  height: 16px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  margin: 10px 167px 10px 548px;
}
</style>
